<div class="title">SELECT SKINS BELOW TO UPGRADE</div>
<div class="items">
  <div class="bg"></div>
  @if (upgraderService.selectedSkinsS().length === 0) {
  <img class="no-items" src="assets/old-images/upgrader-select-skins.png" />
  } @if (upgraderService.selectedSkinsS().length > 0) {
  <div class="multiplier">
    <div class="sub-title">MULTIPLIER</div>
    <div class="value">
      {{
        (
          upgraderService.selectedSkinsPriceS() / upgraderService.betAmount()
        ).toFixed(2)
      }}x
    </div>
  </div>
  @if (upgraderService.selectedSkinsS().length > 1) {
  <div class="items-bg space-x-4">
    @for (skin of upgraderService.selectedSkinsS().slice(1, 5); track $index) {
    <img [src]="skin.image" />
    }
  </div>
  }
  <img
    class="main-item"
    [src]="upgraderService.selectedSkinsS()[0].image"
    (click)="removeFirstItem()"
  />
  @if (upgraderService.selectedSkinsS().length === 1) {
  <div class="item-name">{{ upgraderService.selectedSkinsS()[0].name }}</div>
  } @if (upgraderService.selectedSkinsS().length > 1) {
  <div class="more-items">
    +{{ upgraderService.selectedSkinsS().length - 1 }} more items added
  </div>
  }
  <div
    class="box-yellow-08 box padding-x-12 rounded-4 h-32 flex items-center justify-center"
    style="z-index: 1; margin-top: 12px; border-color: var(--yellow)"
  >
    <app-cost
      [cost]="upgraderService.selectedSkinsPriceS()"
      [balanceType]="sessionService.balanceType()"
      color="var(--yellow)"
    ></app-cost>
  </div>
  }
</div>
